import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-member_ship",
  "use": "icon-member_ship-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-member_ship\"><defs><style></style></defs><path d=\"M646.7 630.3L512.3 316.7 377.9 630.3 221 540.7l67.2 201.6h448.1l67.2-201.6z\" /><path d=\"M915.5 294.3c-24.7 0-44.8 20.1-44.8 44.8 0 11.8 4.5 22.5 12 30.5L690.3 518.3 534.7 159.8h-44.8L334.3 518.3 141.9 369.5c7.4-8 12-18.7 12-30.5 0-24.7-20.1-44.8-44.8-44.8-24.7 0-44.8 20.1-44.8 44.8s20.1 44.8 44.8 44.8l89.6 448.1H826l89.6-448.1c24.7 0 44.8-20.1 44.8-44.8s-20.1-44.7-44.9-44.7zM788.6 787.1H236l-82.1-358.5 201.6 156.8 156.8-380.9 156.8 380.9 201.6-156.8-82.1 358.5zm59.7 89.7H176.2c-12.4 0-22.4 10-22.4 22.4 0 12.4 10 22.4 22.4 22.4h672.1c12.4 0 22.4-10 22.4-22.4 0-12.4-10-22.4-22.4-22.4zM557.1 115c0-24.7-20.1-44.8-44.8-44.8-24.7 0-44.8 20.1-44.8 44.8 0 24.7 20.1 44.8 44.8 44.8 24.7 0 44.8-20 44.8-44.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/member_ship.svg
// module id = LVfw
// module chunks = 78